import PropTypes from "prop-types";
import { makeTreeItem } from "lib/common/components/TreeItem";
import * as React from "react";
import { ConditionalExpander } from "./Expander";
import { validationTreeItemType } from "../types";
import formatId from "lib/formatId";

class ValTreeItem extends React.Component {
    onDoubleClick(e) {
        e.stopPropagation();
        const it = this.props.item;
        it.onNavToField(
            it.entityKey,
            it.recordId,
            it.fieldKey, // may be undefined (for records)
        );
    }

    render() {
        const {
            item,
            toggleControl
        } = this.props;
        const {
            message,
            entityKey,
            recordId,
            fieldKey,
            state,
            nestedState,
            children,
        } = item;
        const classBase = fieldKey || item.cid;
        const classNames = `tree-item-${classBase}`;

        const controlValue = state;
        const indicatorClass = `indicator-container indicator-container-${classBase} is-${state} contains-${nestedState}`;

        const messageClass = `message message-container-${classBase}`;
        const hasChildren = children != null && children.length > 0;
        return (<li className={classNames} id={formatId(`${entityKey}#${recordId}.${fieldKey}`, "val-tree-item")}>
            <div className="tree-row">
                <ConditionalExpander
                    show={hasChildren}
                    expanded={this.props.expanded}
                    onClick={toggleControl.bind(this)}/>
                <div className={indicatorClass}
                     data-shortname={fieldKey}
                     data-control-value={controlValue}
                     data-control-type="validationindicator"
                     onDoubleClick={this.onDoubleClick.bind(this)}
                >
                    <div className="indicator-container-inner">
                        <div className="indicator-top"/>
                        <div className="indicator-bottom"/>
                    </div>
                </div>
                <div className={messageClass}
                     data-control-type="label"
                     onDoubleClick={this.onDoubleClick.bind(this)}
                >
                    {message || "\u00a0"}
                </div>
            </div>
        </li>);
    }
}

ValTreeItem.propTypes = {
    expanded: PropTypes.bool.isRequired,
    item: PropTypes.shape(validationTreeItemType).isRequired,
    toggleControl: PropTypes.func.isRequired,
};

const ValidationTreeItem = makeTreeItem(ValTreeItem);
export default ValidationTreeItem;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/components/ValidationTreeItem.js